import { defineComponent } from 'vue';
import { AppCB } from './AppCB';
import Overview from './pages/overview/Overview.vue';
import Editor from './pages/editor/Editor.vue';
import { setupComponent } from '@studyportals/vue-platform';

export default defineComponent({
	props: {
		page: String,
	},
	components: {
		Overview,
		Editor,
	},
	setup: (props) => {
		const codeBehind = new AppCB(props.page);

		return setupComponent(codeBehind);
	},
});
